import { getPipelineStage } from "./pipelineEngine";

function isPipelineWorker(u = {}) {
  const role = String(
    u.platformRole ||
      u.role ||
      u.userType ||
      ""
  ).toLowerCase();

  const workerType = String(
    u.position ||
      u.primaryRole ||
      u.workerType ||
      u.roleType ||
      ""
  ).toLowerCase();

  return (
    role === "worker" &&
    !["planner", "admin", "owner_admin", "facility_admin_viewer"].includes(
      workerType
    )
  );
}

export function getPipelineCounts(users = [], invites = []) {
  const counts = {
    invited: 0,
    registered: 0,
    onboarding: 0,
    review_queue: 0,
    approved: 0,
    rejected: 0,
  };

  (invites || []).forEach((invite) => {
    const status = String(
      invite.invitationStatus ||
        invite.inviteStatus ||
        invite.status ||
        "invited"
    ).toLowerCase();

    if (["pending", "invited", "sent", "open"].includes(status)) {
      counts.invited += 1;
    }
  });

  (users || []).forEach((u) => {
    if (!isPipelineWorker(u)) return;

   const stage = getPipelineStage(u);

if (stage === "archived") {
  return;
}

if (counts[stage] !== undefined) {
  counts[stage] += 1;
}

  });

  return counts;
}